import { useLang } from "@/lib/i18n";
import { restaurantSchema } from "@/lib/schema";
import { Seo } from "@/components/Seo";
import { Hero, InfoStrip, WhySection, CtaSection } from "@/components/home/HomeSections";
import { SignatureFavorites } from "@/components/SignatureFavorites";
import { ReviewsSection } from "@/components/Reviews";
import { VipSignup } from "@/components/VipSignup";

const schema = restaurantSchema();

export const HomePage = () => {
  const { t } = useLang();
  return (
    <div data-testid="home-page">
      <Seo
        title="Birria Tacos Albuquerque | Tijuas Tacos Birrieria"
        description="Enjoy Tijuana-style birria de res, quesabirria tacos, birria ramen and birria pizza at Tijuas Tacos Birrieria in Albuquerque. Order online or request catering."
        path="/"
        jsonLd={schema}
      />
      <Hero />
      <InfoStrip />
      <SignatureFavorites />
      <section className="bg-hacienda-terracotta py-10 px-4" data-testid="banner-section">
        <p className="max-w-5xl mx-auto text-center font-serif text-3xl md:text-5xl text-white font-semibold italic">“{t("favorites.title")}”</p>
      </section>
      <WhySection />
      <ReviewsSection className="bg-hacienda-cream" />
      <CtaSection />
      <VipSignup />
    </div>
  );
};

export default HomePage;
